import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { AuthReducer } from './reducers/AuthReducer';

const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Configure redux-persist for auth state
const authPersistConfig = {
    key: 'auth',
    storage: storage,
    whitelist: ['auth'], // Only persist auth data, not loading states or messages
    timeout: 0 // Disable timeout
};

const reducers = combineReducers({
    auth: persistReducer(authPersistConfig, AuthReducer),
});

export const store = createStore(reducers, composeEnhancers(middleware));
export const persistor = persistStore(store);
